function determineIfUserIsManager(currentUser) {
  if (currentUser.roleEHS === 'Admin' || currentUser.roleEHS === 'Manager') return true;
  else return false;
}

export default determineIfUserIsManager;
